import { PolicyForm } from 'components/forms/policy-form/policy-form';
import { useCallback } from 'react';
import { clearSelectedAgencies } from 'store/agencies/agencies.slice';
import { closeModal } from 'store/modals/modals.slice';
import { removePolicyFromStore } from 'store/policies/policies.slice';

import { MODAL_POLICY } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { Modal } from '../../template/modals/modal';

export const PolicyModal = () => {
  const dispatch = useAppDispatch();

  const modal = useAppSelector((state) =>
    state.modals.find((modal) => modal.name === MODAL_POLICY),
  );
  const isDirty = useAppSelector((state) => state.formIsDirty.isDirty);
  const isPending = useAppSelector(
    (state) =>
      state.policies.isUpdatePolicyThunkPending ||
      state.policies.isGetPolicyThunkPending,
  );

  const handleClose = useCallback(() => {
    if (isPending) {
      return;
    }

    dispatch(closeModal({ name: MODAL_POLICY }));
    dispatch(clearSelectedAgencies());
    dispatch(removePolicyFromStore());
  }, [dispatch, isPending]);

  if (!modal || !modal.isOpen) {
    return null;
  }

  return (
    <Modal formIsDirty={isDirty} close={handleClose}>
      <PolicyForm />
    </Modal>
  );
};
